
export const Fallback = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100">
            <img
                src="/fav.png"
                alt="Loading..."
                style={{
                    width: 'auto',
                    height: '30px',
                    marginBottom: '20px',
                    animation: 'pulse 1.5s ease-in-out infinite'
                }}
            />


            <p className="mt-1 text-muted">Please wait...</p>

            <style>{`
        @keyframes pulse {
          0% { opacity: 0.6; transform: scale(0.95); }
          50% { opacity: 1; transform: scale(1.05); }
          100% { opacity: 0.6; transform: scale(0.95); }
        }
      `}</style>
        </div>
    )
}